
import { defineComponent } from 'vue';
import HTTP from '@/config/axios-instance';
import { DmButton, DmSelect, DmTextarea, DmInput } from '@dobrymechanik/vue-ui-v2';

interface SelectComponentItem {
  key: string;
  text: string;
  metadata: {
    timeOfDay: any[];
  };
}

const fieldInit: SelectComponentItem = {
  key: '',
  text: '',
  metadata: {
    timeOfDay: []
  }
};

export default defineComponent({
  name: 'OtherForm',
  components: {
    DmButton,
    DmSelect,
    DmTextarea,
    DmInput
  },
  props: {
    dataMechanicId: {
      type: Number,
      default: 0
    },
    dataNoClientParts: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      repairDates: [] as SelectComponentItem[],
      timesOfDay: [] as SelectComponentItem[],
      repairDate: fieldInit as SelectComponentItem,
      timeOfDay: fieldInit as SelectComponentItem,
      car: '' as string,
      ownParts: false as boolean,
      notes: '' as string
    };
  },
  watch: {
    repairDate: {
      handler(value) {
        this.repairDateChange(value);
      },
      deep: true
    }
  },
  mounted() {
    this.GETOtherService();
  },
  methods: {
    async GETOtherService(): Promise<void> {
      const { data } = await HTTP(
        `/api_autobooking/other_services_suggested_dates/${this.dataMechanicId}.json`
      );
      this.repairDates = data.map((e: any) => {
        return {
          key: e.value,
          text: e.name,
          metadata: {
            timeOfDay: e.timeOfDay.map((el: any) => {
              return {
                key: el.value,
                text: el.name
              };
            })
          }
        };
      });
      this.repairDate = this.repairDates[0];

      this.timesOfDay = this.repairDate.metadata.timeOfDay;
      this.timeOfDay = this.repairDate.metadata.timeOfDay[0];
    },
    repairDateChange(repairDate: SelectComponentItem): void {
      const currentDay = this.repairDates.find((e: SelectComponentItem) => {
        return repairDate.key === e.key;
      });
      if (currentDay) {
        this.timesOfDay = currentDay.metadata.timeOfDay;
        this.timeOfDay = this.timesOfDay[0];
      }
    }
  }
});
